import styled from 'styled-components'
import { Form, Button } from 'react-bootstrap'
import { H3 } from '../../typography'
import { weight } from '../../const/fonts'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const RegisterWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  border-radius: 4px;
  background: ${({ theme }) => theme?.appBackground};
`

export const Container = styled.div`
  width: 100%;
  max-width: 80%;
  margin: auto;
  background: ${({ theme }) => theme?.login?.background};
  @media (min-width: 769px) {
    width: 40%;
  }

  .form-control.is-valid {
    background-image: none;
    border: 1px solid ${({ theme }) => theme?.input?.border};
  }
`

export const FormContainer = styled(Form)`
  max-width: 75%;
  margin: 4rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Title = styled(H3)`
  text-align: center;
  font-weight: ${weight.bold};
  position: relative;
  top: 3rem;
`
export const ResendOTPLink = styled.a`
  padding-left: 5px;
  text-decoration: none;
  font-weight: ${weight.bold};
  color: ${({ theme }) => theme?.button?.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme?.button?.primary};
    text-decoration: underline;
  }
`

export const VerifyOTPButton = styled(Button)`
  display: block;
  background: ${({ theme }) => theme?.button?.primary};
  border: none;
`

export const BackToLoginLink = styled(Link)`
  text-decoration: none;
  font-weight: ${weight.bold};
  color: ${({ theme }) => theme?.button?.primary};
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme?.button?.primary};
    text-decoration: underline;
  }
`
export const ChevronLeftIcon = styled(FontAwesomeIcon)`
  position: relative;
  top: 3px;
  right: 2px;
`
